module.exports = "<h2 mat-dialog-title>Delete all</h2>\n<mat-dialog-content>Are you sure?</mat-dialog-content>\n"